export const VIEWED_ARTICLES_COOKIE = 'viewedArticles'
